var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full h-full justify-center items-center"},[_c('div',{staticClass:"lds-ripple h-20 w-20"},[_c('div',{staticClass:"sr-only"},[_vm._v("Please wait, content is loading...")]),_c('div',{staticClass:"h-full w-full rounded-full",attrs:{"aria-hidden":"true"}}),_c('div',{staticClass:"h-full w-full rounded-full",attrs:{"aria-hidden":"true"}})])])
}]

export { render, staticRenderFns }